import React from "react";

export default function RawDogFoodContent() {
  return (
    <div className="flex justify-center items-center min-h-screen py-4">
      <div className="bg-white p-8 shadow-lg rounded-lg w-10/12 md:w-8/12 lg:w-7/12 ">
        <h2 className="text-2xl font-bold mb-4 text-center">
          The Benefits of Raw Dog Food
        </h2>
        <p className="text-lg mb-4">
          Feeding your dog a raw diet comes with a range of health benefits.
          With fresh, natural ingredients, raw meals support better digestion,
          healthier coats, and increased energy levels. Unlike processed kibble,
          raw feeding is free from fillers and artificial additives, meaning
          your dog enjoys food that’s closer to their natural diet.
        </p>
        <p className="text-lg mb-4">
          Our meals follow the BARF dog food diet (Biologically Appropriate Raw
          Food), providing a balance of raw meats, fruits, and vegetables that
          mimic what your dog would eat in the wild. Not only does this lead to
          a happier, healthier pet, but it can also reduce common health issues
          related to processed food and improve their overall well being.
        </p>

        <h3 className="text-xl font-semibold mb-4 text-center">
          Convenient Home Delivery in Melbourne & Sydney
        </h3>
        <p className="text-lg mb-4">
          Say goodbye to the hassle of last-minute trips to the shop. With
          Tucker Tub, you can have fresh meals delivered straight to your door.
          Our service is designed to make your life easier, with flexible
          delivery options that fit around your schedule.
        </p>
        <p className="text-lg mb-4">
          Whether you’re setting up regular deliveries or just need a one-off
          order, we’ve got you covered. Our raw meals are carefully packed to
          ensure they stay fresh, so your dog always enjoys the highest quality
          food.
        </p>

        <h2 className="text-2xl font-bold mb-4 text-center">
          Why Choose Tucker Tub?
        </h2>
        <p className="text-lg mb-4">
          We’re proud to offer locally sourced, human-grade dog food, made from
          the finest Australian ingredients. Our commitment to quality means
          every meal is crafted to deliver maximum nutrition, ensuring your dog
          gets everything they need from their diet.
        </p>
        <p className="text-lg mb-4">
          With Tucker Tub, you’re choosing a brand that cares about your dog’s
          health and nutrition. Our meals are free from preservatives and
          artificial additives, offering a pure and natural dog food option for
          your pet. Plus, with our easy-to-use delivery service, getting fresh
          raw food has never been simpler.
        </p>

        <h3 className="text-xl font-semibold mb-4 text-center">
          Delivery Service Across Victoria & New South Wales
        </h3>
        <p className="text-lg mb-4">
          Tucker Tub delivers throughout Melbourne, Victoria, Sydney and Greater
          Sydney, so no matter where you are, we can bring fresh meals for your
          dog right to your door. From city apartments to country homes, our
          service extends across metro and regional areas—ensuring dogs all over
          Victoria and New South Wales have access to nutritious, raw meals.
        </p>
        <p className="text-lg text-center font-semibold">
          Make the switch to BARF dog food with Tucker Tub today, and see the
          difference a healthy, natural dog diet can make.
        </p>
      </div>
    </div>
  );
}
